import React from 'react';
import { TextField, MenuItem, Box, Typography } from '@mui/material';

const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
    fontSize: { xs: '0.675rem', sm: '0.875rem' },
    '& fieldset': {
      borderColor: '#e2e8f0',
    },
    '&:hover fieldset': {
      borderColor: '#cbd5e1',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1f1f1f',
    },
  },
  '& .MuiInputLabel-root': {
    fontSize: {  xs: '0.675rem', sm: '0.875rem' },
    color: '#737373',
    '&.Mui-focused': {
      color: '#1f1f1f',
    },
  },
};

const DashboardFilters = ({
  filters,
  onFilterChange,
  projects,
  authors,
  repositories,
  showProjectFilter,
  showDateRangeFilter,
  showAuthorFilter,
  showRepoFilter,
}) => {

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4,}}>
      {showProjectFilter && (
        <Box sx={{ display: 'flex',flexDirection: 'column', alignItems: 'flex-start', gap: 1, width: '33%' }}>
         <Typography
         variant="h6"
         sx={{
           color: '#020817',
           fontWeight: 600,
           fontSize: '0.875rem',
           lineHeight: '1.25rem',
         }}
       >
         Project Portfolio
       </Typography>
        <TextField
          select
          value={filters.projectKey || ''}
          onChange={(e) => onFilterChange('projectKey', e.target.value)}
          size="small"
          aria-label="Select project to filter dashboard data"
          role="combobox"
          sx={{
            width: '100%',
            ...textFieldStyles
          }}
          SelectProps={{
            MenuProps: {
              disableScrollLock: true,
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            },
          }}
        >
          {projects.map((proj) => (
            <MenuItem key={proj.api_key} value={proj.api_key}>
              {proj.name || proj.project_name || 'Unnamed Project'}
            </MenuItem>
          ))}
        </TextField>
        </Box>
      )}
      {showDateRangeFilter && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, width: '33%' }}>
          <Typography
            variant="h6"
            sx={{
              color: '#020817',
              fontWeight: 600,
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
            }}
          >
           Time Horizon 
          </Typography>
          <TextField
            select
            name="dateRange"
            value={filters.dateRange || '30d'}
            onChange={(e) => onFilterChange('dateRange', e.target.value)}
            size="small"
            aria-label="Select date range for dashboard data"
            role="combobox"
            sx={{
              width: '100%',
              ...textFieldStyles
            }}
            SelectProps={{
              MenuProps: {
                disableScrollLock: true,
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              },
            }}
          >
            <MenuItem value="7d">Last 7 Days</MenuItem>
            <MenuItem value="30d">Last 30 Days</MenuItem>
            <MenuItem value="90d">Last 90 Days</MenuItem>
            <MenuItem value="180d">Last 180 Days</MenuItem>
            <MenuItem value="overall">Overall</MenuItem>
          </TextField>
        </Box>
      )}
      {showAuthorFilter && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, width: '33%' }}>
          <Typography
            variant="h6"
            sx={{
              color: '#020817',
              fontWeight: 600,
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
            }}
          >
            Team Lead
          </Typography>
          <TextField
            select
            name="author"
            value={filters.author || 'all'}
            onChange={(e) => onFilterChange('author', e.target.value)}
            size="small"
            aria-label="Select author to filter dashboard data"
            role="combobox"
            sx={{
              width: '100%',
              ...textFieldStyles
            }}
            SelectProps={{
              MenuProps: {
                disableScrollLock: true,
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              },
            }}
          >
            {authors.map((author) => (
              <MenuItem key={author} value={author}>
                {author === 'all' ? 'All Authors' : author}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      )}
      {/* {showRepoFilter && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, width: '25%' }}>
          <Typography
            variant="h6"
            sx={{
              color: '#020817',
              fontWeight: 600,
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
            }}
          >
            Repository
          </Typography>
          <TextField
            select
            name="repository"
            value={filters.repository || 'all'}
            onChange={(e) => onFilterChange('repository', e.target.value)}
            size="small"
            aria-label="Select repository to filter dashboard data"
            role="combobox"
            sx={{
              width: '100%',
              ...textFieldStyles
            }}
          >
            {repositories.map((repo) => (
              <MenuItem key={repo} value={repo}>
                {repo === 'all' ? 'All Repositories' : repo}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      )} */}
    </Box>
  );
};

export default DashboardFilters;